export interface SuggestionItemValue {
  query: string;
  count: number;
}

export interface DefaultSuggestionResponse {
  type: string;
  values: SuggestionItemValue[];
}

export enum SourceType {
  Completion = 'completion',
  Product = 'product',
  Category = 'category',
  Brand = 'brand',
}

export enum ArrowEvents {
  Left = 'searchFormArrowLeftClick',
  Right = 'searchFormArrowRightClick',
  Up = 'searchFormArrowUpClick',
  Down = 'searchFormArrowDownClick',
}

export interface Alternative {
  score: number;
  text: string;
  sourceType?: SourceType;
}
export interface SuggestionResponse {
  itemsQuery: string | undefined;
  alternatives: Alternative[] | null;
  items?: RecommendationItem[];
  query: string;
}

export interface SuggestionResponseWithRequestId {
  data: SuggestionResponse;
  xRequestId?: string;
}

export interface DeleteItemResponse {
  message?: string;
  success?: boolean;
  value?: string;
}

export interface HistoryEntries {
  createdAt: string;
  filters: { [key: string]: unknown };
  query: string;
  sort: unknown;
  suggesterType?: string;
  suggesterValue?: string;
}

export interface LocalHistoryItem {
  value: string;
  id: string;
  suggesterType?: string;
  suggesterValue?: string;
  type: string;
}

export interface HistoryResponse {
  email: string;
  entries: HistoryEntries[] | null;
}

export interface RecommendationItem {
  categories: string[];
  id: string;
  name: string;
  imageUrl: string;
  url: string;
  manufacturer: string;
  sku: string;
  variantId: string;
  residential_commercial: string[];
}

export interface InitAutocompleteResult {
  itemsQuery?: string | undefined;
  items?: RecommendationItem[];
  history?: HistoryResponse;
  suggestions?: SuggestionResponse;
  defaultSuggestions?: DefaultSuggestionResponse[];
}

declare global {
  interface Window {
    analytics: any;
  }
}
